var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import moment from "moment";
import { useSelector } from "react-redux";
// stylesheets
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/common.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/time-slot-picker.scss";
// components
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import Man from "./Man";
import TimeSlotPicker from "./TimeSlotPicker";
import otcDi from "../../../../../../../mainDi/features/OTC/servicelocator";
import Edelicon from "@frameworks/shared-library/components/Generic/Edelicon";
import { capitalizeFirstLetter } from "@frameworks/salesjourney/utils/genericMethods";
var LeadeGeneration = function () {
    //
    var _a, _b;
    var _c = __read(useState(false), 2), modifySlot = _c[0], setModifySlot = _c[1];
    var _d = useSelector(function (state) { return state.markets.Otc.registerLeadReducer; }), partnerSelectedSlot = _d.partnerSelectedSlot, registerLead = _d.registerLead;
    var transactionDetails = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }).transactionDetails;
    var nextDays = Array.from({ length: 7 }, function (_, index) { return ({
        label: moment().add(index, "days").format("YYYY-MM-DD"),
        value: moment().add(index, "days").format("YYYY-MM-DD"),
    }); });
    var generateTimeSlots = function () {
        var customSlots = [
            { startHour: 9, endHour: 12, centerHour: "11" },
            { startHour: 13, endHour: 17, centerHour: "4" },
            { startHour: 17, endHour: 19, centerHour: "6" },
        ];
        return customSlots.map(function (_a) {
            var startHour = _a.startHour, endHour = _a.endHour, centerHour = _a.centerHour;
            var start = moment().startOf("day").add(startHour, "hours");
            var end = moment().startOf("day").add(endHour, "hours");
            return {
                label: "".concat(start.format("h A"), " - ").concat(end.format("h A")),
                value: "".concat(start.format("H"), "-").concat(end.format("H")),
            };
        });
    };
    var _e = __read(useState(generateTimeSlots()), 2), availableSlots = _e[0], setAvailableSlots = _e[1];
    useEffect(function () {
        var selectedDate = moment(nextDays[0].value).format("YYYY-MM-DD");
        var futureSlots = availableSlots.filter(function (item) {
            var slotStartTime = moment("".concat(selectedDate, " ").concat(Number(item.value.split("-")[1]) - 1), "YYYY-MM-DD H");
            return !moment().isAfter(slotStartTime);
        });
        if (futureSlots.length > 0) {
            otcDi.registerLead.updatePartnerSlot(__assign(__assign({}, partnerSelectedSlot), { timeSlot: (partnerSelectedSlot === null || partnerSelectedSlot === void 0 ? void 0 : partnerSelectedSlot.timeSlot)
                    ? partnerSelectedSlot === null || partnerSelectedSlot === void 0 ? void 0 : partnerSelectedSlot.timeSlot
                    : futureSlots[0].label, date: (partnerSelectedSlot === null || partnerSelectedSlot === void 0 ? void 0 : partnerSelectedSlot.date)
                    ? partnerSelectedSlot === null || partnerSelectedSlot === void 0 ? void 0 : partnerSelectedSlot.date
                    : nextDays[0].value }));
        }
        else {
            otcDi.registerLead.updatePartnerSlot(__assign(__assign({}, partnerSelectedSlot), { timeSlot: (partnerSelectedSlot === null || partnerSelectedSlot === void 0 ? void 0 : partnerSelectedSlot.timeSlot)
                    ? partnerSelectedSlot === null || partnerSelectedSlot === void 0 ? void 0 : partnerSelectedSlot.timeSlot
                    : availableSlots[0].label, date: (partnerSelectedSlot === null || partnerSelectedSlot === void 0 ? void 0 : partnerSelectedSlot.date)
                    ? partnerSelectedSlot === null || partnerSelectedSlot === void 0 ? void 0 : partnerSelectedSlot.date
                    : moment().add(1, "days").format("YYYY-MM-DD") }));
        }
    }, []);
    var CheckDate = function (date) {
        var label = "";
        for (var i = 0; i <= 7; i++) {
            var checkDate = moment().add(i, "days").format("YYYY-MM-DD");
            if (date === checkDate) {
                label =
                    i === 0
                        ? "Today"
                        : i === 1
                            ? "Tomorrow"
                            : moment().add(i, "days").format("dddd");
                break;
            }
        }
        return label;
    };
    return (React.createElement("div", { className: "aif-pms-sidebar-body" },
        React.createElement("div", { className: "custom-tabs-container" },
            React.createElement("div", { className: "rounded lead-generation-height width-375 position-relative w-100 overflow-hidden" },
                React.createElement("div", { className: " d-flex gap-1 p-3 box-shadow-light aif-pms-genericScheme-sec align-items-center" },
                    React.createElement(Edelicon, { className: "edel-icon-product-bag fs-24", paths: 3 }),
                    React.createElement("span", { className: "DMSanM_14_500 txt_blackOne1" }, capitalizeFirstLetter(transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.ncdName))),
                React.createElement("div", { className: "d-flex flex-column align-items-center gap-24 auto-height-lead py-5-new" },
                    React.createElement("div", null,
                        React.createElement(Man, null)),
                    React.createElement("div", { className: "d-flex flex-column align-items-center gap-3 " },
                        React.createElement("p", { className: "text-center DMSanM_16_500 txt_purple-gray text-center" }, ((_a = registerLead === null || registerLead === void 0 ? void 0 : registerLead.data) === null || _a === void 0 ? void 0 : _a.exist) == "Y" ? (React.createElement("span", null,
                            "We have already received",
                            React.createElement("br", null),
                            "your interest. Our wealth expert",
                            React.createElement("br", null),
                            "will reach out to you.")) : (React.createElement("span", null,
                            "Your wealth expert will",
                            React.createElement("br", null),
                            " reach out to you"))),
                        React.createElement("div", { className: "d-flex flex-column align-items-center gap-2 lead" },
                            React.createElement("div", { className: "d-flex gap-2 align-items-center" },
                                React.createElement("p", { className: "DMSanN_14_400 txt-whispering-periwinkle " }, "You'll get a call-back by"),
                                " ",
                                React.createElement("p", { className: "DMSanM_14_500 ".concat(!modifySlot
                                        ? "time-selected-default"
                                        : "time-selected underline", " ") },
                                    CheckDate(partnerSelectedSlot.date),
                                    " ",
                                    partnerSelectedSlot.timeSlot),
                                modifySlot && (React.createElement("p", { onClick: function () {
                                        setModifySlot(false);
                                    } },
                                    React.createElement("i", { className: "edel-icon-editicon-underline d-flex align-items-center justify-content-center " })))),
                            !modifySlot && !((_b = registerLead === null || registerLead === void 0 ? void 0 : registerLead.data) === null || _b === void 0 ? void 0 : _b.leadId) && (React.createElement(EdButton, { onClick: function () {
                                    setModifySlot(true);
                                    otcDi.registerLead.updatePartnerLead(null);
                                }, btnTyp: "blue-one", value: React.createElement("div", { className: "d-flex gap-2 align-items-center" },
                                    React.createElement("span", { className: "DMSanM_14_500 text-white" }, "Modify Time Slot"),
                                    React.createElement("i", { className: "edel-icon-editicon-underline d-flex align-items-center justify-content-center" })), className: "rounded-pill DMSanM_14_500 p-block-6 p-inline-16 align-items-center" })))),
                    modifySlot && (React.createElement(TimeSlotPicker, { indexV: moment().add(1, "days").format("YYYY-MM-DD") ===
                            partnerSelectedSlot.date
                            ? 1
                            : 0 })))))));
};
export default LeadeGeneration;
